import { ReactComponent as VerifiedIconSvg } from "../../icons/verfied.svg";

export default function VerifiedIcon({...props}){
  return(
    <VerifiedIconSvg width={"28px"} height={"28px"} fill="#00B3FF" {...props}/>
  )
}

